module.exports = __webpack_public_path__ + "4294c6ddd1f81e99b94d2d54f5aec32a.MP3";